import { type ObjectValues } from "@iyk/prelude"
import { type Duration } from "effect"
import type { Nullable } from "./type-utils.ts"

export interface AppConfig<T extends string = string> {
  appId: T
  admins?: {
    mfaEnabled: boolean
    otpExpiration: Duration.DurationInput
    sessionDuration: Duration.DurationInput
  }
  cookiePrefix: string
  lang: Lang
  artist: {
    name: string
  }
  meta: {
    description: string
  }
  emailSender: {
    name: string
    email: string
  }
  s3: {
    assets: {
      baseUrl: string
      vfUrl: string
      appUrl: string
    }
    files: {
      exclusives: string
      fanClips: string
      merchSkus: string
      playlistCoverImages: string
      showImages: string
      showCheckInRequestImages: string
    }
    music: {
      trackAudios: string
      playlistDownloadFiles: string
    }
  }
  shopUrl: Nullable<string>
  socialLinks: Array<SocialPlatformLink>
  merch: {
    initialOwnerId: string
    initialOwnerAddress: `0x${string}`
  }
  joinProof: Nullable<JoinProofConfig>
  tasks: {
    exclusiveLinkDelay: Duration.DurationInput
  }
  checkIn: {
    hidePrompt: boolean
  }
  assets: Assets
}

export type JoinProofConfig = {
  name: string
  assets: {
    backgroundImage: string
    og: string
    icon: string
    image: string
    thumbnail: string
  }
}

export type Lang = "EN" | "ES" | "KO"

export const SocialPlatform = {
  Instagram: "instagram",
  TikTok: "tiktok",
  Youtube: "youtube",
  Facebook: "facebook",
  Twitter: "twitter",
  Twitch: "twitch",
  Discord: "discord",
  Website: "website",
  Spotify: "spotify",
  AppleMusic: "apple-music",
  SoundCloud: "soundcloud"
} as const

export type SocialPlatform = ObjectValues<typeof SocialPlatform>

export interface SocialPlatformLink {
  platform: SocialPlatform
  label: string
  href: string
}

interface Assets {
  images: {
    avatar: string
    og: string
    logo: {
      url: string
      width: number
    }
    background: string
    howToTap: Nullable<string>
    enableLocation: {
      ios: {
        step1: string
        step2: string
      }
      android: {
        step1: string
      }
    }
    email: {
      logo: {
        url: string
        width: number
      }
    }
    roulette: {
      images: Array<string>
    }
  }
  videos: {
    marquee: Nullable<string>
    howToTap: Nullable<string>
  }
  documents: {
    privacyPolicy: string
    termsOfService: string
    artistPrivacyPolicy: Nullable<string>
    artistTermsOfService: Nullable<string>
    sweepstakeRules: Nullable<string>
  }
}
